module.exports = __webpack_public_path__ + "static/media/glass.36bef15a.svg";